/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ width: NonNullable<unknown>, height: NonNullable<unknown> }} Image_Inspector_Dimensions_ValueInputs */

const en_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const ar_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} بكسل`)
};

const bn_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const de_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const es_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const fr_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const pt_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const zh_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const tr_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const ru_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

const pl_image_inspector_dimensions_value = /** @type {(inputs: Image_Inspector_Dimensions_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.width} × ${i?.height} px`)
};

/**
* | output |
* | --- |
* | "{width} × {height} px" |
*
* @param {Image_Inspector_Dimensions_ValueInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_dimensions_value = /** @type {((inputs: Image_Inspector_Dimensions_ValueInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Dimensions_ValueInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_dimensions_value(inputs)
	if (locale === "bn") return bn_image_inspector_dimensions_value(inputs)
	if (locale === "de") return de_image_inspector_dimensions_value(inputs)
	if (locale === "es") return es_image_inspector_dimensions_value(inputs)
	if (locale === "fr") return fr_image_inspector_dimensions_value(inputs)
	if (locale === "pt") return pt_image_inspector_dimensions_value(inputs)
	if (locale === "zh") return zh_image_inspector_dimensions_value(inputs)
	if (locale === "tr") return tr_image_inspector_dimensions_value(inputs)
	if (locale === "ru") return ru_image_inspector_dimensions_value(inputs)
	if (locale === "pl") return pl_image_inspector_dimensions_value(inputs)
	return en_image_inspector_dimensions_value(inputs)
});